// Remove SX props
import { PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

const MultiStepCard = ({ children }: PropsWithChildren) => {
  const location = useLocation();
  const isTransferPage =
    location?.pathname?.endsWith('transfer') ||
    location.pathname.includes('domains');

  return (
    <Card
      sx={{
        mb: 1,
        maxWidth: isTransferPage ? '100%' : 640 /* or 'sm' which is 600 */,
      }}
    >
      <CardContent>{children}</CardContent>
    </Card>
  );
};

export default MultiStepCard;
